<dx-popup
  [width]="950"
  [height]="700"
  [showTitle]="true"
  class="intervention-report-popup"
  [title]="title"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [elementAttr]="{ class: 'intervention-report-popup' }"
  (onHidden)="closed($event)"
  (onShowing)="onShowing($event)"
  (onShown)="onShown($event)"
  [(visible)]="visible">
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Fermer',
            onClick: close
        }">
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <dx-tabs
      [dataSource]="[{id: 0, text: 'Rapport'}, {id: 1, text: 'La Carte'}]"
      [selectedIndex]="0"
      (onItemClick)="selectTab($event)"
    ></dx-tabs>
    <div *ngIf="selectedTab === 0" class="report-content">
      <div class="p-4">
        <h3 class="font-light border-b border-gray-300 mb-2">
          <span *ngIf="intervention.field">Parcelle {{intervention.field.name}}</span>
          <span *ngIf="!intervention.field">Intervention Reconstruite</span>
          <span class="float-right text-base" *ngIf="intervention.start_time && intervention.stop_time">
            {{intervention.start_time | date :'shortTime'}} - {{intervention.stop_time | date :'shortTime'}} ({{intervention.start_time | date :'shortDate'}})
          </span>
        </h3>
        <div class="mb-3 flex gap-2 flex-wrap items-center">
          <lib-badge *ngIf="intervention.validation_accuracy" [color]="getValidationAccuracyColor(intervention.validation_accuracy)">
            {{getValidationAccuracyLabel(intervention.validation_accuracy)}}
          </lib-badge>
          <lib-badge *ngIf="intervention.culture_name" color="blue">
            Culture: {{intervention.culture_name}}
          </lib-badge>
          <lib-badge *ngIf="intervention.rejection_reason" color="red">
            Rejeté: {{intervention.rejection_reason}}
          </lib-badge>
        </div>
        <div class="mb-3 flex gap-2" *ngIf="isPendingValidation()">
          <dx-button
            *ngIf="canValidate"
            type="success"
            text="Valider l'Intervention"
            [icon]="'<svg width=\'18px\' height=\'18px\' viewBox=\'0 0 24 24\'>' + checkIcon.body + '</svg>'"
            (onClick)="validateIntervention()">
          </dx-button>
          <dx-button
            *ngIf="canReject"
            type="danger"
            text="Rejeter l'Intervention"
            [icon]="'<svg width=\'18px\' height=\'18px\' viewBox=\'0 0 24 24\'>' + closeIcon.body + '</svg>'"
            (onClick)="rejectIntervention()">
          </dx-button>
        </div>
        <div class="grid p-1 grid-cols-4 gap-3 history-metrics">
          <div title="Superficie" class="shadow-sm hover:shadow cursor-pointer" *ngIf="intervention.field && intervention.field.polygon_area">
            <div class="metric-text">Totale</div>
            <span class="metric-value">{{(intervention.field.polygon_area / 10000).toFixed(2)}} <span
              class="metric-unit">Ha</span></span>
          </div>
          <div title="Superficie Travaillée" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Travaillée</div>
            <span class="metric-value">{{(intervention.working_area_ha || 0).toFixed(2)}} <span
              class="metric-unit">Ha</span></span>
          </div>
          <div title="Percentage" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Percentage</div>
            <span class="metric-value">{{((intervention.working_area_percent || 0) * 100).toFixed(1)}} <span
              class="metric-unit">%</span></span>
          </div>
          <div title="Débit" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Débit</div>
            <span class="metric-value">{{(intervention.working_hectare_per_hour || 0).toFixed(2)}} <span
              class="metric-unit">Ha/h</span></span>
          </div>
        </div>
      </div>
      <div class="p-4 pt-0">
        <div class="grid grid-cols-2 gap-3">
          <div>
            <h3 class="font-light border-b border-gray-300 mb-2">Vitesse Travail</h3>
            <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
              <div title="Moyenne" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Moyenne</div>
                <span class="metric-value">{{(intervention.working_in_field_speed_avg || 0).toFixed(2)}} <span
                  class="metric-unit">Km/h</span></span>
              </div>
              <div title="Maximale" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Maximale</div>
                <span class="metric-value">{{(intervention.working_in_field_speed_max || 0).toFixed(2)}} <span
                  class="metric-unit">Km/h</span></span>
              </div>
            </div>
            <h3 class="font-light border-b border-gray-300 mt-4 mb-2">Machines & Outils</h3>
            <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
              <div title="Tracteur" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Tracteur</div>
                <span class="metric-value">{{intervention.tractor_name || 'N/A'}}</span>
              </div>
              <div title="Outil" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Outil</div>
                <span class="metric-value">{{intervention.trailer_name || 'N/A'}}</span>
              </div>
              <div title="Largeur de Travail" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Largeur de Travail</div>
                <span class="metric-value">{{intervention.trailer_width ? (intervention.trailer_width / 100).toFixed(2) : '0.00'}} <span
                  class="metric-unit">m</span></span>
              </div>
            </div>
          </div>
          <app-time-pie-chart title="Temps" [data]="timeReport"></app-time-pie-chart>
        </div>
      </div>
    </div>
    <div style="position: relative" [ngClass]="{'invisible': selectedTab !== 1}">
      <div id="intervention-report-map" class="intervention-report-map"
           leaflet
           [leafletOptions]="mapOptions"
           (leafletMapReady)="onMapReady($event)">
      </div>
      <app-map-layers-control [mapReady]="mapReady$" [layers]="layers"></app-map-layers-control>
      
      <!-- Polygon editing controls - HIDDEN FOR NOW -->
      <!-- <div class="map-edit-controls" *ngIf="!isEditingPolygon && canEditPolygon()">
        <dx-button
          type="default"
          text="Modifier Zone de Travail"
          icon="edit"
          (onClick)="startEditingPolygon()">
        </dx-button>
      </div>
      
      <div class="map-edit-controls editing" *ngIf="isEditingPolygon">
        <dx-button
          type="success"
          text="Enregistrer"
          [icon]="'<svg width=\'18px\' height=\'18px\' viewBox=\'0 0 24 24\'>' + saveIcon.body + '</svg>'"
          [disabled]="isSavingPolygon"
          (onClick)="saveEditedPolygon()">
        </dx-button>
        <dx-button
          type="danger"
          text="Annuler"
          [icon]="'<svg width=\'18px\' height=\'18px\' viewBox=\'0 0 24 24\'>' + cancelIcon.body + '</svg>'"
          [disabled]="isSavingPolygon"
          (onClick)="cancelEditingPolygon()">
        </dx-button>
      </div> -->
    </div>
  </div>
</dx-popup>

<app-validate-dialog
  #validateDialog
  (onValidate)="onValidateSuccess()">
</app-validate-dialog>

<app-reject-dialog
  #rejectDialog
  (onReject)="onRejectSuccess()">
</app-reject-dialog>
